export var removeWidthAndHeightFromRichTextImage = function (html) {
    if (html.trim() === '')
        return html;
    var htmlString = html;
    try {
        var fragment = document.createRange().createContextualFragment(html);
        var imgs = fragment.querySelectorAll('img');
        // 遍历富文本中的img标签，删除尺寸属性，防止内联样式无法被覆盖导致图片超出聊天框
        imgs.forEach(function (img) {
            img.removeAttribute('width');
            img.removeAttribute('height');
        });
        var div = document.createElement('div');
        div.appendChild(fragment.cloneNode(true));
        htmlString = div.innerHTML;
    }
    catch (error) {
        console.error('[Utils-removeWidthAndHeightFromRichTextImage]', 'error when removing width and height from rich text', error);
    }
    return htmlString;
};
export var genRichText = function (str) { return (str ? str.replace(/&lt;/g, '<').replace(/&gt;/g, '>') : ''); };
export var formatRichText = function (message) {
    // 删除富文本中图片宽度
    var nextHtmlString = removeWidthAndHeightFromRichTextImage(message);
    return genRichText(nextHtmlString);
};
// 处理富文本点击事件
export var clickRichText = function (tagName, callback) { return function (e) {
    var _a;
    if (((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.tagName) === tagName) {
        callback(e.target);
    }
}; };
